export default __webpack_public_path__ + "static/media/ImpactoZ_BannerPrincipal.81975109.jpg";